import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { usePermissions } from "hooks/permission";

import { CardAdminItem } from "features/CardAdminItem";
import { ReactPaginateKenta } from "features/cruds/ReactPaginate";
import { AdminAreaSkeleton } from "features/LoadSkeleton";
import { LoadSpinner } from "features/LoadSpinner";

import { DropdownGlobal } from "components/DropdownGlobal";
import GeneralInput from "components/GeneralInput";
import PageHeader from "components/PageHeader";

import { Container, ContainerBody, SkeletonContainer } from "./styles";
import "./styles.css";

type AdmProps = {
  title: string;
  InputSearchLabel: string;
  InputSearchOnChange?: (text: string) => any;
  list: Array<any>;
  headerAddButtonOnClick?: () => unknown;
  headerTrashButtonOnClick?: () => unknown;
  onClick: (item: any) => void;
  setOpenModal: any;
  searchText: string;
  permissionName: string;
  focusInputSearch?: boolean;
  onChangeSituation?: any;
  displayAtivoFilter?: boolean;
  showStatus?: boolean;
  description?: boolean;
  showSearch?: boolean;
  setItemReturnClick?: any;
  setIsEdit?: (isEdit: boolean) => any;
  loading?: boolean;
  serverSidePagination?: boolean;
  totalCount?: number;
  currentPage?: number;
  serverPageCount?: number;
  onPageChange?: (page: number) => void;
};

export function AdminArea({
  title,
  InputSearchLabel,
  InputSearchOnChange,
  list,
  headerAddButtonOnClick,
  onClick,
  searchText,
  onChangeSituation,
  displayAtivoFilter = true,
  showStatus = true,
  description = false,
  showSearch = true,
  loading = false,
  permissionName,
  setIsEdit,
  serverSidePagination = false,
  totalCount,
  currentPage = 0,
  serverPageCount = 0,
  onPageChange,
}: AdmProps) {
  const { t } = useTranslation();
  const inputRef = React.useRef<HTMLInputElement>(null);
  const { read, create, edit } = usePermissions(permissionName);

  const options = [
    {
      id: 1,
      name: t("common.active"),
      datacy: "ativo",
    },
    {
      id: 0,
      name: t("common.inactive"),
      datacy: "inativo",
    },
    {
      id: 2,
      name: t("common.all"),
      datacy: "todos",
    },
  ];

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const listComponent =
    read &&
    list &&
    list?.map((item: any, index: number) => (
      <CardAdminItem
        key={index}
        id={item?.id}
        name={description ? item.description : item?.name}
        active={item.active}
        data-cy={item?.name}
        onClickEditAction={() =>
          edit ? onClick({ ...item, selected: true }) : null
        }
        disable={edit ? false : true}
        showStatus={showStatus}
        setIsEdit={setIsEdit}
        selected={item?.selected}
      />
    ));

  return (
    <Container>
      <PageHeader
        quantity={
          read
            ? serverSidePagination
              ? totalCount ?? 0
              : list?.length > 0
                ? list.length
                : 0
            : 0
        }
        id="header"
        data-cy="header"
        label={title}
        background="secondary"
        addClick={
          create && headerAddButtonOnClick ? headerAddButtonOnClick : undefined
        }
        disabled={create ? false : false}
      />
      <ContainerBody>
        {showSearch ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-center",
              alignItems: "flex-center",
              marginTop: "8px",
              marginBottom: "22px",
            }}
          >
            <div style={{ width: "400px" }}>
              <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                <GeneralInput
                  id="busca"
                  data-cy="busca"
                  name={`busca`}
                  label={InputSearchLabel}
                  value={searchText}
                  onChange={(e) =>
                    InputSearchOnChange && InputSearchOnChange(e)
                  }
                  autoComplete="off"
                  height="52px"
                />
              </form>
            </div>
            {displayAtivoFilter ? (
              <div style={{ marginLeft: 40, marginTop: 7 }}>
                <DropdownGlobal
                  labelName={t("common.status")}
                  data-cy="situacao"
                  options={options}
                  setSelected={(value: any) => onChangeSituation(value)}
                  defaultValue={t("common.all")}
                  showDefaultValue
                  height="52px"
                  width="136px"
                  required={false}
                  withoutMarginBottom={true}
                />
              </div>
            ) : null}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-center",
              alignItems: "flex-center",
              marginTop: "8px",
              marginBottom: "22px",
            }}
          ></div>
        )}

        {loading ? (
          <SkeletonContainer>
            <AdminAreaSkeleton />
            <LoadSpinner loading={loading} />
          </SkeletonContainer>
        ) : (
          <ReactPaginateKenta
            list={listComponent}
            title={title}
            onChangePage={
              serverSidePagination && onPageChange
                ? onPageChange
                : () => {}
            }
            loading={loading}
            serverSidePagination={serverSidePagination}
            serverPageCount={serverPageCount}
            serverCurrentPage={currentPage}
          />
        )}
      </ContainerBody>
    </Container>
  );
}
